import * as React from "react";
import { cn } from "@/lib/utils";

/** A copy of {@link FormMessage} but does not depend on react-hook-forms */
const ErrorMessage = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn("text-[0.8rem] font-medium text-destructive", className)}
      {...props}
    >
      {children}
    </p>
  );
});
ErrorMessage.displayName = "ErrorMessage";

export { ErrorMessage };
